<template>
  <div
    class="components-header"
    :class="{
      show: show || path != '/' || popovershow,
      top: path == '/',
    }"
    @mouseenter="show = true"
    :style="{
      background:
        active == 1 || active == 8 || active == 2 || active == 5
          ? 'transparent'
          : 'rgba(0, 0, 0, 0.4)',
    }"
    @mouseleave="show = false"
  >
    <div class="outbox" @mouseenter="active = active">
      <div class="inner">
        <div class="left">
          <!-- <img
            v-if="show || path != '/' || popovershow"
            src="/static/images_v5/logo.webp"
            @click="beforePush('/')"
          />
          <img
            v-else
            src="/static/images/titleimg.webp"
            @click="beforePush('/')"
          /> -->
          <img
            @click="beforePush('/')"
            src="/static/images_20230726/logo.webp"
          />
          <div
            v-if="path != '/cn/taskDetail' && path != '/cn/mycloud'"
            class="menu"
          >
            <!-- <div
              :class="{ active: titleActive == 1 }"
              @mouseover="
                active = 7;
                show = true;
                titleActive = 1;
              "
              @mouseleave="
                active = 7;
                show = true;
                currentSay();
              "
              @click="$router.push('/')"
            >
              <div class="name">首页</div>
            </div> -->
            <div
              :class="{ active: titleActive == 2 }"
              @mouseover="
                titleActive = 2;
                active = 1;
                show = true;
              "
              @mouseleave="active = 1"
            >
              <div class="name">产品中心</div>
            </div>
            <div
              :class="{ active: titleActive == 10 }"
              @mouseover="
                titleActive = 10;
                active = 10;
              "
              @mouseleave="
                active = 10;
                currentSay();
              "
              @click="$router.push('/cn/skyCloud')"
            >
              <div class="name">低空云</div>
            </div>
            <div
              :class="{ active: titleActive == 9 }"
              @mouseover="
                titleActive = 9;
                active = 9;
              "
              @mouseleave="
                active = 9;
                currentSay();
              "
              @click="open('https://www.get3d.cn/')"
            >
              <div class="name">云端地球</div>
            </div>
            <div
              :class="{ active: titleActive == 4 }"
              @mouseover="
                titleActive = 4;
                active = 9;
              "
              @mouseleave="
                active = 9;
                currentSay();
              "
              @click="$router.push('/cn/wise')"
            >
              <div class="name">智慧文博</div>
            </div>
            <div
              :class="{ active: titleActive == 3 }"
              @mouseover="
                titleActive = 3;
                active = 8;
              "
              @mouseleave="active = 8"
            >
              <div class="name">解决方案</div>
            </div>
            <div
              :class="{ active: titleActive == 5 }"
              @mouseover="
                active = 2;
                titleActive = 5;
              "
              @mouseleave="active = 2"
              @click="$router.push('/cn/sustain')"
            >
              <div class="name">服务支持</div>
              <!-- <transition name="el-zoom-in-top">
                <div
                  style="bottom: -137px"
                  class="sdown"
                  v-show="active == 2"
                  @mouseenter="
                    active = 2;
                    show = true;
                  "
                  @mouseleave="
                    show = false;
                    active = '';
                  "
                >
                  <div
                    @click="
                      open('https://www.get3d.cn/');
                      show = false;
                      active = '';
                    "
                  >
                    云端建模
                  </div>
                  <div
                    @click="
                      $router.push('/cn/service');
                      show = false;
                      active = '';
                    "
                  >
                    数据服务
                  </div>
                  <div
                    @click="
                      $router.push('/cn/wise');
                      show = false;
                      active = '';
                    "
                  >
                    智慧文博
                  </div>
                </div>
              </transition> -->
            </div>
            <!-- <div
              :class="{ active: active == 3 }"
              @mouseenter="active = 3"
              @mouseleave="active = ''"
            >
              <div
                class="name"
                @click="
                  $router.push('/cn/cases');
                  show = false;
                  active = '';
                "
              >
                案例
              </div>
            </div> -->
            <!-- <div
              :class="{ active: active == 4 }"
              @mouseenter="
                active = 4;
                show = true;
              "
              @mouseleave="active = ''"
              @mouseover="
                active = 4;
                show = true;
              "
            >
              <div class="name">探索</div>
              <transition name="el-zoom-in-top">
                <div
                  class="sdown"
                  v-show="active == 4"
                  @mouseenter="
                    active = 4;
                    show = true;
                  "
                  @mouseleave="
                    show = false;
                    active = '';
                  "
                  style="bottom: -98px"
                >
                  <div
                    @click="
                      open('https://www.get3d.cn/square');
                      show = false;
                      active = '';
                    "
                  >
                    模型广场
                  </div>
                  <div
                    @click="
                      $router.push('/cn/news');
                      show = false;
                      active = '';
                    "
                  >
                    新闻中心
                  </div>
                </div>
              </transition>
            </div> -->
            <!-- <div
              :class="{ active: active == 6 }"
              @mouseenter="active = 6"
              @mouseleave="active = ''"
            >
              <div
                class="name"
                @click="
                  $router.push('/cn/download');
                  show = false;
                  active = '';
                "
              >
                下载
              </div>
            </div> -->
            <div
              :class="{ active: titleActive == 6 }"
              @mouseover="
                active = 5;
                titleActive = 6;
              "
              @mouseleave="active = 5"
            >
              <div class="name">关于我们</div>
            </div>
          </div>
        </div>
        <div class="right" v-if="false">
          <!-- <span
            style="display: inline-block; height: 60px"
            @mouseenter="popovershow = false"
          >
            <el-button
              v-if="path != '/cn/taskDetail'"
              class="button"
              type="primary"
              size="mini"
              @click="addRebuild"
              style="width: 100px"
              >+ 立即建模</el-button
            >
          </span>-->
          <el-popover
            v-if="login"
            placement="bottom"
            width="138"
            popper-class="smpopover"
            trigger="manual"
            v-model="popovershow"
          >
            <!--<div class="popcontent">-->
            <!--<div class="row">-->
            <!--<div class="left">-->
            <!--<el-tag type="" effect="dark" size="mini" class="tag">建模</el-tag>-->
            <!--</div>-->
            <!--<div class="right">-->
            <!--<div>您的模型<span>武汉大学行政楼</span>已完成，<span class="a">立即前往</span>查看。</div>-->
            <!--<div>2020-11-07 13:02:11</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="row">-->
            <!--<div class="left">-->
            <!--<el-tag type="success" effect="dark" size="mini" class="tag">公告</el-tag>-->
            <!--</div>-->
            <!--<div class="right">-->
            <!--<div>重建云2.0已更新版本，<span class="a">立即前往</span>下载。</div>-->
            <!--<div>2020-11-07 13:02:11</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--<hr style="margin-top: 13px">-->
            <!--<div class="btns">-->
            <!--<div>-->
            <!--<el-button class="sbtn" @click="$router.push('/cn/mycloud'); popovershow = false">我的任务</el-button>-->
            <!--<el-button class="sbtn" @click="$router.push('/cn/mycloud?active=2'); popovershow = false">我的模型</el-button>-->
            <!--</div>-->
            <!--<div>-->
            <!--<el-button class="sbtn" @click="$router.push('/cn/download'); popovershow = false">下载中心</el-button>-->
            <!--<el-button class="sbtn" @click="$router.push('/cn/user'); popovershow = false">账户信息</el-button>-->
            <!--</div>-->
            <!--</div>-->
            <!--<hr style="margin-top: 20px">-->
            <!--<div class="logout" @click="logOut">-->
            <!--<div>安全退出</div>-->
            <!--</div>-->
            <!--</div>-->
            <div
              class="popcontent"
              style="padding-top: 10px; padding-bottom: 10px"
            >
              <div
                class="litmenu"
                @click="
                  $router.push('/cn/mycloud');
                  popovershow = false;
                "
              >
                <img src="/static/images_v5/51.webp" alt />
                <span>我的任务</span>
              </div>

              <div
                class="litmenu"
                @click="
                  $router.push('/cn/mycloud?active=2');
                  popovershow = false;
                "
              >
                <img src="/static/images_v5/52.webp" alt />
                <span>我的模型</span>
              </div>
              <div
                class="litmenu"
                @click="
                  $router.push('/cn/download');
                  popovershow = false;
                "
              >
                <img src="/static/images_v5/53.webp" alt />
                <span>下载中心</span>
              </div>
              <hr
                style="
                  mborder-color: #ebebeb;
                  width: 120px;
                  margin: 10px auto 0;
                "
              />
              <div class="logout" @click="logOut">
                <div style="color: #212121">退出</div>
              </div>
            </div>
            <span
              slot="reference"
              style="height: 57px; display: inline-block; position: relative"
              @mouseenter="popovershow = path != '/cn/taskDetail'"
            >
              <el-avatar
                class="avatar"
                :size="30"
                :src="info.avatar"
              ></el-avatar>
            </span>
          </el-popover>
          <span v-else class="login" @click="$router.push('/cn/login')">
            <div>登录</div>
          </span>
          <span
            style="
              display: inline-block;
              width: calc(50% - 600px);
              height: 60px;
              position: absolute;
              right: 0;
            "
            @mouseenter="popovershow = false"
          ></span>
        </div>
      </div>
    </div>
    <transition name="el-zoom-in-top">
      <div
        class="down"
        v-show="active == 1 || active == 8 || active == 2 || active == 5"
        @mouseenter="
          show = true;
          active = active;
        "
        @mouseleave="
          show = false;
          active = titleActive = '';
        "
      >
        <div class="downinner">
          <template v-if="active == 1">
            <div class="card" style="margin-left: 200px">
              <div class="title">采集设备</div>
              <div class="title2" @click="$router.push('/cn/doublefish8x')">
                双鱼系列
              </div>
              <div class="tip">保密倾斜摄影相机</div>
              <div class="title2" @click="$router.push('/cn/dshot')">
                定拍DShot
              </div>
              <div class="tip">便携式空间影像采集仪</div>
              <div class="title2" @click="$router.push('/cn/rtk')">MiniRTK</div>
              <div class="tip">智能、轻巧、便携</div>
            </div>
            <div class="card">
              <div class="title">图像激光融合装备</div>
              <div class="title2" @click="$router.push('/cn/wisdomR100')">
                智影 R100
              </div>
              <div class="tip">可建模的全场景SLAM三维激光扫描仪</div>
              <div class="title2" @click="$router.push('/cn/wisdomS100')">
                智影 S100
              </div>
              <div class="tip">可建模的轻巧手持SLAM三维激光扫描仪</div>
              <!-- <div class="title2" @click="$router.push('/cn/solnsight')">
                速影 L100
              </div>
              <div class="tip">机载激光扫描仪 快速建模</div> -->
              <div class="title2" @click="$router.push('/cn/hawkeye')">
                鹰眼
              </div>
              <div class="tip">实时建模一体化设备</div>
            </div>
            <div class="card">
              <div class="title">三维重建系列</div>
              <div class="title2" @click="$router.push('/cn/gcluster')">
                重建大师
              </div>
              <div class="tip">大规模实景三维集群建模软件</div>
              <div
                class="title2"
                @click="$router.push('/cn/cluster-satellite')"
              >
                重建大师卫星版
              </div>
              <div class="tip">超大规模卫星影像集群处理软件</div>
              <div class="title2" @click="open('https://get3d.cn/')">
                云端地球
              </div>
              <div class="tip">实景三维建模云平台</div>
              <div class="title2" @click="$router.push('/cn/nongchang')">
                重建农场
              </div>
              <div class="tip">实景三维数据中心解决方案</div>
              <div class="title2" @click="$router.push('/cn/farmsecurity')">
                重建农场信创版
              </div>
              <div class="tip">信创全流程实景三维数据生产中心</div>
              <div class="title2" @click="$router.push('/cn/farmlite')">
                重建农场便携版
              </div>
              <div class="tip">移动的实景三维数据处理中心</div>
            </div>
            <div class="card">
              <div class="title">后处理与应用软件</div>
              <div class="title2" @click="$router.push('/cn/mofang')">模方</div>
              <div class="tip">实景三维模型修编与单体化工具</div>
              <div class="title2" @click="$router.push('/cn/dasviewer')">
                DasViewer
              </div>
              <div class="tip">实景三维极速浏览器</div>
              <div class="title2" @click="$router.push('/cn/dasmesh')">
                网格大师
              </div>
              <div class="tip">实景三维数据治理专家</div>
              <!-- 标记isShowTime -->
              <template v-if="isShowTime()">
                <div class="tip">实景三维数据治理软件</div>
                <div class="title2" @click="$router.push('/cn/mp')">
                  贴图大师
                </div>
                <div class="tip">文物建模无损贴图工具</div>
                <div class="title2" @click="$router.push('/cn/verification')">
                  检校大师
                </div>
                <div class="tip">航测相机检校软件</div>
              </template>
            </div>
          </template>
          <template v-if="active == 8">
            <div class="card card2" style="margin-left: 320px">
              <div class="title">行业应用解决方案</div>
              <div class="title2 single-title" @click="$router.push('/cn/nrs')">
                自然资源监管
              </div>
              <div
                class="title2 single-title"
                @click="$router.push('/cn/mine')"
              >
                矿山监管
              </div>
              <div
                class="title2 single-title"
                @click="$router.push('/cn/farmhouse')"
              >
                农房核查
              </div>
              <div
                class="title2 single-title"
                @click="$router.push('/cn/emergency')"
              >
                灾害现场快速三维态势感知
              </div>
              <!-- <div class="title2 single-title" @click="$router.push('/cn/cim')">
                CIM与CIM+
              </div>
              <div class="title2 single-title" @click="$router.push('/cn/meta')">
                元宇宙数字生命
              </div>
              <div class="title2 single-title" @click="$router.push('/cn/natural')">
                自然资源监管
              </div>
              <div class="title2 single-title" @click="$router.push('/cn/village')">
                乡村振兴
              </div> -->
            </div>
            <div class="card card2" style="width: 204px">
              <div class="title">文化遗产解决方案</div>
              <div
                class="title2 single-title"
                @click="$router.push('/cn/wise')"
              >
                智慧文旅
              </div>
              <!-- <div class="title2 title3">
                行业应用解决方案
              </div>
              <div class="tip cp" @click="$router.push('/cn/cim')">
                CIM与CIM+
              </div>
              <div class="tip cp" @click="$router.push('/cn/meta')">
                元宇宙数字生命
              </div>
              <div class="tip cp" @click="$router.push('/cn/natural')">
                自然资源监管
              </div>
              <div class="tip cp" @click="$router.push('/cn/village')">
                乡村振兴
              </div>
              <div class="title2 title3">
                数据生产解决方案
              </div>
              <div class="tip cp" @click="$router.push('/cn/nongchang')">
                数据中心软硬件一体化解决方案
              </div>
              <div class="tip cp" @click="$router.push('/cn/service')">
                数据服务
              </div> -->
            </div>
            <div class="card card2">
              <div class="title">数据生产解决方案</div>
              <div
                class="title2 single-title"
                @click="$router.push('/cn/service')"
              >
                数据服务
              </div>
              <div
                class="title2 single-title"
                @click="$router.push('/cn/nongchang')"
              >
                数据中心
              </div>
            </div>
          </template>
          <template v-if="active == 2">
            <div class="card card3 fifth-card">
              <div class="title">服务支持</div>
              <div class="title2" @click="$router.push('/cn/download')">
                下载中心
              </div>
              <div
                class="title2"
                @click="
                  $router.push('/cn/sustain?scroll=true&scrollPos=communicate')
                "
              >
                技术支持
              </div>
              <div
                class="title2"
                @click="open('https://docs.qq.com/form/page/DQU5pdWVLS0FLTHZO')"
              >
                我要投诉
              </div>
              <div
                class="title2"
                @click="open('https://docs.qq.com/form/page/DQU5pdWVLS0FLTHZO')"
              >
                软件建议
              </div>
              <div class="title2" @click="$router.push('/cn/faq')">
                常见问题
              </div>
              <div
                class="title2"
                @click="
                  $router.push('/cn/sustain?scroll=true&scrollPos=question')
                "
              >
                教学视频
              </div>
            </div>
          </template>
          <template v-if="active == 5">
            <div class="card card3 last-card">
              <div
                class="title2"
                style="margin-top: 0"
                @click="$router.push('/cn/about')"
              >
                公司介绍
              </div>
              <div
                class="title2"
                @click="$router.push('/cn/enterpriseCooperation')"
              >
                代理商政策
              </div>
              <div class="title2" @click="$router.push('/cn/cases')">
                合作案例
              </div>
              <div class="title2" @click="$router.push('/cn/news')">
                新闻中心
              </div>
              <div class="title2">
                <a
                  href="https://www.zhipin.com/gongsir/254ee1f246c4427d1nF80tq9FQ~~.html?ka=company-jobs"
                  target="_blank"
                  rel="nofollow"
                  style="color: inherit"
                >
                  加入我们
                </a>
              </div>
            </div>
          </template>

          <!-- <div class="card">
            <div class="title">核心技术</div>
            <div
              class="title2"
              @click="
                $router.push('/cn/engin');
                show = false;
                active = '';
              "
            >
              G-Engine
            </div>
            <div class="tip">实景三维自动重建超算引擎</div>
          </div> -->
          <!-- <div class="card">
            <div class="title">软件</div>
            <div
              class="title2"
              @click="
                $router.push('/cn/gcluster');
                show = false;
                active = '';
              "
            >
              重建大师
            </div>

            <div class="tip">大规模实景三维集群建模软件</div>
            <div
              class="title2"
              @click="
                $router.push('/cn/mofang');
                show = false;
                active = '';
              "
            >
              模方
            </div>
            <div class="tip">实景三维修模神器</div>
            <div
              class="title2"
              @click="
                $router.push('/cn/dasviewer');
                show = false;
                active = '';
              "
            >
              DasViewer
            </div>
            <div class="tip">实景三维极速浏览器</div>
            <div
              class="title2"
              @click="
                $router.push('/cn/dasmesh');
                show = false;
                active = '';
              "
            >
              网格大师
            </div>
            <div class="tip">实景三维治理专家</div>
            <div
              v-if="isBanner"
              class="title2"
              @click="
                $router.push('/cn/mp');
                show = false;
                active = '';
              "
            >
              贴图大师
            </div>

            <div v-else class="title2" style="cursor: not-allowed">
              贴图大师
            </div>
            <div class="tip">超真实感贴图设计的软件</div>
          </div> -->
          <!-- <div class="card">
            <div class="title">硬件</div>
            <div
              class="title2"
              @click="
                $router.push('/cn/nongchang');
                show = false;
                active = '';
              "
            >
              重建农场
            </div>
            <div class="tip">实景三维数据中心解决方案</div>
            <div
              class="title2"
              @click="
                $router.push('/cn/doublefish8x');
                show = false;
                active = '';
              "
            >
              双鱼系列
            </div>
            <div class="tip">双鱼倾斜智能相机</div>
            <div
              class="title2"
              @click="
                $router.push('/cn/rtk');
                show = false;
                active = '';
              "
            >
              MiniRTK
            </div>
            <div class="tip">智能、轻巧、便携</div>
            <div
              class="title2"
              @click="
                $router.push('/cn/dshot');
                show = false;
                active = '';
              "
            >
              定拍（DShot）
            </div>
            <div class="tip">便携式空间影像采集仪</div>
          </div> -->
          <!-- <div class="card">
            <div class="title">平台</div>
            <div class="title2" @click="open('https://earth.daspatial.com')">
              云端地球
            </div>
            <div class="tip">实景三维建模云平台</div>
            <div class="title2" @click="open('https://gis.daspatial.com')">
              实景三维GIS平台
            </div>
          </div> -->
        </div>
      </div>
    </transition>
    <div
      v-if="popovershow"
      @mouseenter="
        popovershow = false;
        show = false;
      "
      class="down2"
    ></div>

    <el-dialog
      title="新建任务"
      :visible.sync="dialogVisible"
      class="dialogsm"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="400px"
    >
      <div class="dialogcontent">
        <div class="left">
          <div class="title2"><span class="err">*</span>名称</div>
          <div>
            <el-input
              v-model="formdata.name"
              size="mini"
              style="width: 100%"
            ></el-input>
          </div>
          <div class="title2">描述</div>
          <div>
            <el-input
              type="textarea"
              :rows="3"
              v-model="formdata.desc"
              size="mini"
              style="width: 100%"
            ></el-input>
          </div>
          <div class="bottom" style="margin-top: 40px">
            <el-button @click="dialogVisible = false" size="mini"
              >取 消</el-button
            >
            <el-button type="primary" size="mini" @click="addTask"
              >创 建</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import userApi from "@/api/user";
import taskApi from "@/api/task";
import $ from "jquery";

document.addEventListener(
  "DOMContentLoaded",
  function (event) {
    // chrome 浏览器直接加上下面这个样式就行了，但是ff不识别
    document.body.style.zoom = "reset";
    document.addEventListener(
      "keydown",
      function (event) {
        if (
          (event.ctrlKey === true || event.metaKey === true) &&
          (event.which === 61 ||
            event.which === 107 ||
            event.which === 173 ||
            event.which === 109 ||
            event.which === 187 ||
            event.which === 189)
        ) {
          event.preventDefault();
        }
      },
      { passive: false }
    );
    document.addEventListener(
      "mousewheel DOMMouseScroll",
      function (event) {
        if (event.ctrlKey === true || event.metaKey) {
          event.preventDefault();
        }
      },
      { passive: false }
    );
  },
  { passive: false }
);

document.addEventListener(
  "keydown",
  function (event) {
    if (
      (event.ctrlKey === true || event.metaKey === true) &&
      (event.which === 61 ||
        event.which === 107 ||
        event.which === 173 ||
        event.which === 109 ||
        event.which === 187 ||
        event.which === 189)
    ) {
      event.preventDefault();
    }
  },
  { passive: false }
);

window.addEventListener(
  "DOMMouseScroll",
  function (event) {
    if (event.ctrlKey === true || event.metaKey) {
      event.preventDefault();
    }
  },
  { passive: false }
);

window.addEventListener(
  "mousewheel",
  function (event) {
    if (event.ctrlKey === true || event.metaKey) {
      event.preventDefault();
    }
  },
  { passive: false }
);

export default {
  components: {},
  name: "components-header",
  data() {
    return {
      isBanner: true,
      active: 7,
      titleActive: 1,
      show: false,
      language: "Ch",
      login: global.apis.isLogin(),
      path: this.$router.currentRoute.path,
      info: {},
      popovershow: false,
      dialogVisible: false,
      newsTitle: "",
      formdata: {
        name: "",
        desc: "",
      },
    };
  },
  watch: {
    // 监控路由变化
    $route: function () {
      // this.getBackground(); //首页哀悼主题滤镜
      let route = this.$route.path.split("/");
      if (route[1] != "cn" && route[1] != "en") this.changeLanguage("Ch");
      this.path = this.$router.currentRoute.path;

      this.login = global.apis.isLogin();

      //        this.routerCheck()

      this.menu();

      this.changeHeader();

      if (this.login) this.getUserInfo();
    },
    newsTitle: function () {
      this.changeHeader();
    },
  },
  created() {
    this.currentSay();
    if (applimit.mplimit.enable)
      this.tieMap(applimit.mplimit.startTime, applimit.mplimit.endTime);
    let route = this.$route.path.split("/");
    // 小于1024跳转到移动版
    //    if (document.documentElement.clientWidth <= 1024) {
    //      if (route[1] == "en") window.location = "https://m.daspatial.com/en/engin"
    //      else window.location = "https://m.daspatial.com/"
    //    }
    if (route[1] == "en") global.apis.setLanguage("En");
    else global.apis.setLanguage("Ch");

    this.login = global.apis.isLogin();
    this.language = global.apis.getLanguage();

    var metas = document.getElementsByTagName("meta");
    if (this.language == "Ch") {
      $("title").html("武汉大势智慧-实景三维-云端建模-新型基础设施");
      metas[2].content =
        "三维数据服务,倾斜摄影,实景三维,云端建模,全自动三维重建,智慧文博,文物数字化,数字孪生,智慧城市,新型基础测绘,新型基础设施";
      metas[3].content =
        "武汉大势智慧科技有限公司专注于真实世界三维数字化重建及实景三维数据服务，在大规模快速高精度实景三维建模、模型内容感知、模型自动单体化、三维模型全流程生产领域具有领先的技术优势和丰富的实践经验。";
    } else if (this.language == "En") {
      $("title").html(
        "Daspatial-Build Spatial Temporal Infrastructure of the Future World"
      );
      metas[2].content =
        "3D data service,3D model,Oblique photography,Real-time automatic 3D reconstruction,3D project management,3D digitalization,3D-Digitization,3D data collections,Cloud 3D model,G-Engine,3D semantic segmentation,GIS Platform,GIS map,Digital twin,AI 3D modeling,Inclined  camera,3D visualization,Aerial triangulation,3D data processing,Inclined camera,3D modeling software,3D modeling foundament.";
      metas[3].content =
        "Daspatial focuses on researches of 3D modeling,and developed a series of photogrammetric automatic modeling,model editing software,and inclined cameras.Our technologies and products have been used in extensive fields of digitalization,such as city construction and planning.";
    }

    if (this.login) this.getUserInfo();

    //      this.routerCheck()

    this.menu();
    this.changeHeader();

    this.$bus.$on("addtask", () => {
      this.addRebuild();
    });
    this.$bus.$on("newstitleChange", (val) => {
      console.log(val, "666");
      this.newsTitle = "实景三维 " + val;
    });
  },
  mounted() {
    //首页哀悼主题滤镜
    // this.getBackground();
  },
  methods: {
    isShowTime() {
      let showLimitTimes = ["2024-10-21 08:30:00", "2024-10-21 09:00:00"];

      let now = new Date().getTime();
      let start = new Date(showLimitTimes[0]).getTime();
      let end = new Date(showLimitTimes[1]).getTime();

      return now >= start && now <= end;
    },
    currentSay() {
      // if()
      this.titleActive = "";
      // let path = this.$route.path;
      // if (path == "/") this.titleActive = 1;
      // else if (path == "/cn/wise") this.titleActive = 4;
      // else if (path == "/cn/about" || path == "/cn/news") this.titleActive = 6;
    },
    //首页哀悼主题滤镜
    getBackground() {
      if (this.$route.path == "/") {
        $("html").addClass("gaytype");
      } else {
        $("html").removeClass("gaytype");
      }
    },
    //贴图大师阶段性隐藏
    tieMap(start, end) {
      start = start.split("-").join(" ");
      start = Date.parse(start);
      end = end.split("-").join(" ");
      end = Date.parse(end) + 24 * 60 * 60 * 1000;
      if (new Date().getTime() > end || new Date().getTime() < start)
        this.isBanner = true;
      else this.isBanner = false;
    },
    addRebuild() {
      if (this.login) {
        this.dialogVisible = true;
      } else {
        this.$router.push("/cn/login");
      }
    },
    beforePush(path) {
      if (this.path == "/cn/taskDetail") {
        this.$confirm(
          "离开当前页面将清除所有照片记录，上传中的任务也会被取消。",
          "提示",
          {
            confirmButtonText: "取消",
            cancelButtonText: "确认离开",
            distinguishCancelAndClose: true,
            type: "warning",
          }
        )
          .then(() => {})
          .catch((action) => {
            if (action === "cancel") {
              this.$router.push(path);
            }
          });
      } else this.$router.push(path);
    },
    addTask() {
      if (!this.formdata.name) {
        this.$message.warning("名称不能为空");
        return false;
      }

      let params = {
        name: this.formdata.name,
      };

      taskApi.addTask(params).then((res) => {
        this.dialogVisible = false;
        this.formdata = {
          name: "",
          desc: "",
        };

        this.$router.push("/cn/taskDetail?tid=" + res.data.data.id);
      });
    },
    open(url) {
      window.open(url);
    },
    tz_say() {
      location.href = "https://data.daspatial.com";
    },
    changeHeader() {
      let path = this.$router.currentRoute.path;
      let metas = document.getElementsByTagName("meta");
      if (path.split("/")[1] == "cn") {
        switch (path) {
          case "/cn":
            $("title").html("武汉大势智慧-实景三维-云端建模-新型基础设施");
            metas[2].content =
              "三维数据服务,倾斜摄影,实景三维,云端建模,全自动三维重建,智慧文博,文物数字化,数字孪生,智慧城市,新型基础测绘,新型基础设施";
            metas[3].content =
              "武汉大势智慧科技有限公司专注于真实世界三维数字化重建及实景三维数据服务，在大规模快速高精度实景三维建模、模型内容感知、模型自动单体化、三维模型全流程生产领域具有领先的技术优势和丰富的实践经验。";
            break;
          case "/cn/engin":
            $("title").html("G-Engine-大势智慧实景三维自动重建引擎");
            metas[2].content =
              "自动重建引擎,人工智能,无限空三,重建质量提升,几何优化,三维建模,实景三维中国";
            metas[3].content =
              "G-Engine是一款拥有完全自主知识产权的实景三维自动重建引擎，完美结合倾斜摄影和计算机视觉领域中的最新研究成果。";
            break;
          case "/cn/gcluster":
            $("title").html("重建大师-超大规模实景三维集群建模软件");
            metas[2].content =
              "自动化重建,大规模三维重建,卫星建模,LOD 1.3,LOD 2.0,城市快速建模,重建即单体,内容感知重建,多源数据融合,下视航空摄影快速重建,实景三维,新型基础测绘,";
            metas[3].content =
              "新一代重建大师6.0质效双升，支持卫片、下视航片、彩色激光点云等多源数据建模，实现城市LOD 1.3/2.0模型快速构建，助力实景三维中国建设。";
            break;
          case "/cn/mofang":
            $("title").html("模方-为精致的实景三维数据而生");
            metas[2].content =
              "地理场景修饰,单体化建模,模型后处理,联动DShot地面视角修,整体匀色,局部匀色,跨区域联合修模,无损拓扑置平,多瓦片联合处理";
            metas[3].content =
              "具备地理场景修饰与单体化建模的实景三维模型修复编辑软件。模方4.0新增地面视角修复、局部和整体匀光匀色、联动3ds max单体化建模等多个功能，让人工更高效。";
            break;
          case "/cn/nongchang":
            $("title").html("重建农场-实景三维数据中心解决方案");
            metas[2].content =
              "高密重建算力机,软硬一体,mesh数据生产,LOD 1.3/3.0生产,三维场景修饰,单体化建模,白天工作机,晚上算力机,占地一平方,一天七万张,新型基础测绘,实景三维中国";
            metas[3].content =
              "重建农场内置全新重建大师，模方，DasViewer，网格大师，调度大师全流程数据生产软件，满足实景三维全场景作业生产需求。";
            break;
          case "/cn/dasviewer":
            $("title").html("DasViewer-免费极速实景三维模型浏览器");
            metas[2].content =
              "实景三维浏览器,添加水印,双屏浏览,精度检查,三维可视化,一键打开模型";
            metas[3].content =
              "让用户以极低的电脑配置，流畅加载大规模实景三维模型，提供方便快捷的数据浏览操作。";
            break;
          case "/cn/dasmesh":
            $("title").html("网格大师-实景三维治理专家");
            metas[2].content =
              "局部更新,轻量化,坐标系转换,格式转换,多机并行,数据融合,数据转换,实景三维重建";
            metas[3].content =
              "实景三维数据生产治理软件，具备轻量化、坐标系转换、格式转换多个数据处理功能，与大势智慧模方、重建大师、DasViewer合力打造实景三维模型局部更新解决方案。";
            break;
          case "/cn/mp":
            $("title").html("贴图大师-超真实感贴图设计软件");
            metas[2].content =
              "精准高效贴图,虚拟相机映射,控制点映射,平面映射,高清贴图,便捷修复,纹理无缝拼接,色彩接缝羽化,PS联动修复,壁画纠正,实时贴图";
            metas[3].content =
              "贴图大师是大势智慧自主研发的一站式解决三维模型纹理贴图的专业软件，实现二维影像到三维几何模型的精准映射，完美解决图像色差和纹理接缝问题，轻松完成模型贴图工作。";
            break;
          case "/cn/doublefish8x":
            $("title").html("双鱼8X系列-保密倾斜相机");
            metas[2].content =
              "原片加密,原始影像加密,存储保密,质检保密,专业质检软件大势云观,内业解密,数据安全,新型基础测绘,";
            metas[3].content =
              "大势智慧首创外业数据采集加密、数据安全拷贝、航片专有软件质检、内业网络解密等方式，保障影像数据从外业到内业全流程安全，适用于多场景建模需求。";
            break;
          case "/cn/rtk":
            $("title").html("MiniRTK-口袋版RTK-智能、轻巧、便携");
            metas[2].content =
              "多场景应用,专业工程测量,像控点布设,地形图测量,工程放点,道路测量,管线巡检,文物考古";
            metas[3].content =
              "智能、轻巧、便携高精度GNSS接收机，支持全球五大导航系统。产品依托大势智慧云平台，打通传统内外行业壁垒，实现RTK应用服务云端化。";
            break;
          case "/cn/dshot":
            $("title").html("定拍DShot-便携式空间影像采集仪");
            metas[2].content =
              "空间影像采集,地面视角修复,空地融合,边走边拍,全域土地整治,矿山巡查执法,生态合作,开放SDK,新型基础测绘";
            metas[3].content =
              "大势智慧自主研发的便携式空间影像采集仪，集高精度定姿、高精度定位于一体，联动模方实现地面视角快速修复，相对传统补拍贴图方式纹理处理效率提升2.1倍。";
            break;
          case "/cn/service":
            $("title").html("实景三维一站式数据服务-深度定制行业解决方案");
            metas[2].content =
              "三维数据服务,倾斜摄影,数据采集,数据生产,自动化三维重建,数据处理,模型精修,实景三维建模";
            metas[3].content =
              "大势智慧在三维数据的生产和处理领域已深耕十年，致力于为客户提供高分辨率倾斜摄影数据采集、高质量实景三维重建、高效率模型精修、轻量级三维交互展示等各类定制化实景三维数据服务。";
            break;
          case "/cn/wise":
            $("title").html("智慧文博-用科技传承文明");
            metas[2].content =
              "文物数字化,可移动文物,不可移动文物,“空、天、地”一体化,云渲染,智慧博物馆,革命文物活化利用";
            metas[3].content =
              "大势智慧深耕文化遗产数字化、博物馆智慧化建设，形成了智慧保护、智慧研究、智慧服务、智慧管理、智慧运维等智慧博物馆业务应用体系，广泛应用于全国各地大、中、小型博物馆与纪念馆。";
            break;
          case "/cn/cases":
            $("title").html("合作案例-构建世界的时空基础");
            metas[2].content =
              "高精度数据采集,三维精细建模,模型后处理,实景三维应用,智慧城市,景区遗址,智慧文博,应急管理,自然资源,公共安防,城市规划,实景三维中国";
            metas[3].content =
              "大势智慧自主研发的实景三维重建软硬件覆盖全国100多家省、市测绘院及城市规划设计研究院等单位，深度服务于实景三维中国建设与新型基础测绘试点建设。";
            break;
          case "/cn/casedetail":
            $("title").html("合作案例-构建世界的时空基础");
            metas[2].content =
              "高精度数据采集,三维精细建模,模型后处理,实景三维应用,智慧城市,景区遗址,智慧文博,应急管理,自然资源,公共安防,城市规划,实景三维中国";
            metas[3].content =
              "大势智慧自主研发的实景三维重建软硬件覆盖全国100多家省、市测绘院及城市规划设计研究院等单位，深度服务于实景三维中国建设与新型基础测绘试点建设。";
            break;
          case "/cn/download":
            $("title").html("软件下载-构建世界的时空基础");
            metas[2].content =
              "重建大师,重建农场,双鱼倾斜相机,MiniRTK,DShot,模方,DasViewer,双鱼系列,大势云观,贴图大师,实景三维中国";
            metas[3].content =
              "大势智慧打造全流程全自主实景三维数据生产体系，汇聚数据采集、自动重建、模型后处理、数据质检、成果汇交、生产管理于一体，深度服务国家新型基础测绘与实景三维中国建设。";
            break;
          case "/cn/about":
            $("title").html("关于大势智慧-构建世界的时空基础");
            metas[2].content =
              "高精度数据采集,三维精细建模,模型后处理,实景三维,三维重建,新型基础测绘,实景三维中国";
            metas[3].content =
              "大势智慧是一家专注于真实世界三维数字化重建及三维数据服务的高新技术企业，创始团队成员主要来自武汉大学测绘遥感信息工程国家重点实验室，公司在城市高精度三维建模、模型应用及语义化理解和文化遗产数字化保护领域具有绝对领先的技术优势和丰富实践经验。";
            break;
          case "/cn/newsdetail":
            $("title").html(this.newsTitle);
            metas[2].content =
              "重建大师,重建农场,实景三维,三维重建,三维建模,三维模型,新型基础测绘,实景三维中国";
            metas[3].content =
              "专注于真实世界三维数字化重建及实景三维数据服务，为用户提供最优质的实景三维数据服务，助力实景三维中国建设";
            break;
          default:
            $("title").html("武汉大势智慧-实景三维-云端建模-新型基础设施");
            metas[2].content =
              "三维数据服务,倾斜摄影,实景三维,云端建模,全自动三维重建,智慧文博,文物数字化,数字孪生,智慧城市,新型基础测绘,新型基础设施";
            metas[3].content =
              "武汉大势智慧科技有限公司专注于真实世界三维数字化重建及实景三维数据服务，在大规模快速高精度实景三维建模、模型内容感知、模型自动单体化、三维模型全流程生产领域具有领先的技术优势和丰富的实践经验。";
            break;
        }
      }
    },
    getUserInfo() {
      let _this = this;
      userApi
        .getUserInfo({})
        .then((res) => {
          if (res.data.code == 0) {
            _this.info = res.data.data.info;
          } else _this.logOut();
        })
        .catch(function (e) {
          _this.logOut();
        });
    },
    logOut() {
      userApi
        .logOut({})
        .then((res) => {
          //          if (res.data.code == 0) {
          global.apis.doLogout();
          this.login = false;

          if (this.language == "Ch") this.$router.push("/");
          else if (this.language == "En") this.$router.push("/en/gclient");
          //          }
        })
        .catch(function (e) {});
    },
    // 路由检测
    routerCheck() {
      let path = this.$router.currentRoute.path;

      if (this.language == "Ch") {
        if (path == "/privacy_En") this.$router.replace("/privacy");
        else if (path == "/legal_En") this.$router.replace("/legal");
        else if (path == "/login_En") this.$router.replace("/login");
        else if (path == "/regist_En") this.$router.replace("/regist");
        else if (path == "/resetpass_En") this.$router.replace("/resetpass");
        else if (path == "/desktop_En") this.$router.replace("/desktop");
        else if (path == "/about_En") this.$router.replace("/about");
        else if (path == "/gclient_En") this.$router.replace("/gclient");
        else if (path == "/engin_En") this.$router.replace("/engin");
      } else if (this.language == "En") {
        if (path == "/privacy") this.$router.replace("/privacy_En");
        else if (path == "/legal") this.$router.replace("/legal_En");
        else if (path == "/login") this.$router.replace("/login_En");
        else if (path == "/regist") this.$router.replace("/regist_En");
        else if (path == "/resetpass") this.$router.replace("/resetpass_En");
        else if (path == "/desktop") this.$router.replace("/desktop_En");
        else if (path == "/about") this.$router.replace("/about_En");
        else if (path == "/gclient") this.$router.replace("/gclient_En");
        else if (path == "/engin") this.$router.replace("/engin_En");
        // 取消个人中心
        else if (path == "/user") this.$router.replace("/desktop_En");
        // 其它跳转到英文首页
        else if (path == "/") this.$router.replace("/gclient_En");
      }
    },
    changeLanguage(language) {
      global.apis.setLanguage(language);
      this.language = language;

      var metas = document.getElementsByTagName("meta");
      if (this.language == "Ch") {
        $("title").html("武汉大势智慧-实景三维-云端建模-新型基础设施");
        metas[2].content =
          "三维数据服务,倾斜摄影,实景三维,云端建模,全自动三维重建,智慧文博,文物数字化,数字孪生,智慧城市,新型基础测绘,新型基础设施";
        metas[3].content =
          "武汉大势智慧科技有限公司专注于真实世界三维数字化重建及实景三维数据服务，在大规模快速高精度实景三维建模、模型内容感知、模型自动单体化、三维模型全流程生产领域具有领先的技术优势和丰富的实践经验。";

        this.$router.replace("/");
      } else if (this.language == "En") {
        $("title").html(
          "Daspatial-Build Spatial Temporal Infrastructure of the Future World"
        );
        metas[2].content =
          "3D data service,3D model,Oblique photography,Real-time automatic 3D reconstruction,3D project management,3D digitalization,3D-Digitization,3D data collections,Cloud 3D model,G-Engine,3D semantic segmentation,GIS Platform,GIS map,Digital twin,AI 3D modeling,Inclined  camera,3D visualization,Aerial triangulation,3D data processing,Inclined camera,3D modeling software,3D modeling foundament.";
        metas[3].content =
          "Daspatial focuses on researches of 3D modeling,and developed a series of photogrammetric automatic modeling,model editing software,and inclined cameras.Our technologies and products have been used in extensive fields of digitalization,such as city construction and planning.";

        this.$router.replace("/en/gclient");
      }
    },
    regist() {},
    menu() {
      let path = this.$router.currentRoute.path;

      document.documentElement.scrollTop = 0;
    },
    to(path) {
      this.$router.push(path);
    },
    //      logout(){
    //        global.apis.doLogout()
    //        this.$router.push("/login")
    //      },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.gaytype {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(1);
}

a {
  text-decoration: none;
}

.btn {
  width: 140px;
  border: 1px solid white;
  border-radius: 4px !important;
  cursor: pointer;
  font-weight: 500;
  margin: 20px auto 0;
  padding: 5px 0;
  text-align: center;
  /*box-shadow:0px 0px 27px 0px rgba(0, 0, 0, 0.15);*/
}

.btn.sp {
  border: 1px solid rgba(45, 142, 247, 1);
  color: rgba(45, 142, 247, 1);
}

.btn:hover {
  background-color: rgba(45, 142, 247, 1);
  border-color: rgba(45, 142, 247, 1) !important;
  color: white !important;
}

.btn.sp:hover {
  color: white;
}

.codeleft .el-input__inner {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.coderight {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.el-dialog__body {
  padding-bottom: 40px;
  padding-top: 20px;
}

.spmsgbox .el-message-box__status {
  font-size: 40px !important;
  display: block;
  position: unset;
  margin: 10px auto 0;
  width: 40px;
}

.spmsgbox .el-message-box__status + .el-message-box__message {
  padding: 0;
  text-align: center;
}

.spmsgbox .el-message-box__btns {
  text-align: center;
  margin-top: 10px;
}

.el-dialog {
  border-radius: 6px;
}

@font-face {
  font-family: en1;
  src: url("/static/font/en.ttf");
}

hr {
  border: none;
  border-bottom: 1px solid #c9c9c9;
}
</style>
<style scoped>
.components-header {
  left: 0;
  position: fixed;
  top: 0;
  z-index: 11;
  font-size: 14px;
  width: 100%;
  height: 70px;

  color: white;
  min-width: 1200px;
  background: rgba(0, 0, 0, 0.4);
}

.components-header.top {
  position: absolute;
}

/* .components-header.show {
  background-color: white;
  transition: all 0.3s ease;
  color: #212121;
} */
.components-header .outbox {
  position: relative;
  min-width: 1200px;
}

/* .components-header.show .outbox {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
} */
.components-header .inner {
  width: 1200px;
  height: 70px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.left {
  display: flex;
  margin: 0 auto;
}

.left img {
  width: 88px;
  height: 30px;
  object-fit: cover;
  margin-top: 18px;
  cursor: pointer;
}

.left .menu {
  display: flex;
  /* margin-left: 35px; */
  font-weight: bold;
}

.left .menu > div {
  cursor: pointer;
  position: relative;
  margin: 10px 0 0 70px;
  padding: 13px 10px 21px;
}

.left .menu > div .name {
  /* padding: 0 10px; */
  display: inline-block;
  height: 16px;
  line-height: 16px;
  font-size: 14px;
  padding-bottom: 1px;
  /* line-height: 60px; */
  /* margin: 27px 15px 0; */
  border-bottom: 1px solid transparent;
}

/* .left .menu > div .name:hover {
  border-bottom: 1px solid #1472e2;
  color: #1472e2;
} */
.left .menu > div.active .name {
  border-bottom: 1px solid #1472e2;
  color: #1472e2;
}

.right {
  display: flex;
}

.right .button {
  margin-right: 30px;
  margin-top: 15px;
}

.right .login div {
  cursor: pointer;
  margin-top: 20px;
  line-height: 20px;
}

.down {
  position: absolute;
  /* background-color: white; */
  /* min-height: 356px; */
  width: 100%;
  overflow: hidden;
  z-index: -1;
  left: 0;
  top: 0;
  padding-top: 70px;
  color: #212121;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(3px);
}

.down .downinner {
  width: 1200px;
  /* width: 1000px; */
  margin: 0 auto;
  padding: 22px 0 24px;
  display: flex;

  /* padding-left: 135px; */
}

.down .downinner .card {
  /* padding: 0 30px; */
  margin-right: 50px;
}

/* .down .downinner .card + .card {
  border-left: 1px solid #e5e5e5;
} */
.down2 {
  position: absolute;
  height: 400px;
  width: 100%;
  overflow: hidden;
  z-index: -1;
  bottom: -415px;
}

.card .title {
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.55);
  margin-bottom: 10px;
}

.card .tip {
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  /* margin-top: 5px; */
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 10px;
}

.card2 .tip {
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  margin-bottom: 0 !important;
}

/* .card .tip + .title2 {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.9);
} */
.card .title3 {
  margin-top: 10px;
}

.card .title3:hover {
  color: rgba(255, 255, 255, 0.9) !important;
}

.card .title2 {
  font-size: 16px;
  height: 28px;
  line-height: 28px;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  /* display: inline-block; */
  font-weight: bold;
}

.card .single-title {
  padding-bottom: 10px;
}

.card .title2:hover {
  color: #1472e2;
  /* text-decoration: underline; */
}

.card3 .title2 {
  margin-top: 10px;
}

.fifth-card {
  /* margin-right: 0 !important; */
  margin-left: 78.5%;
}

.last-card {
  margin-left: 89.5%;
  margin-right: 0 !important;
  transform: translateX(18%);
}

.sdown {
  background-color: white;
  position: absolute;
  bottom: -137px;
  left: -10px;
  text-align: center;
  width: 100px;
  z-index: -1;
  font-weight: 400;
  padding: 10px 0;
}

.sdown div {
  padding: 10px 0;
}

.sdown div:hover {
  background-color: #e5e5e5;
}

.avatar {
  position: relative;
  top: 14px;
  height: 45px;
}

.popcontent .row {
  margin-top: 20px;
  display: flex;
  font-size: 12px;
}

.popcontent .row .left {
  margin-right: 10px;
}

.popcontent .row .right {
  padding-top: 2px;
  display: block;
}

.popcontent .row .right span {
  color: rgba(45, 142, 247, 1);
}

.popcontent .row .right .a {
  cursor: pointer;
  text-decoration: underline;
}

.popcontent .btns {
  margin-top: 16px;
}

.popcontent .btns > div {
  display: flex;
  justify-content: space-between;
}

.popcontent .btns > div + div {
  margin-top: 10px;
}

.popcontent .logout div {
  font-size: 14px;
  margin: 20px auto 10px;
  width: 80px;
  cursor: pointer;
  text-align: center;
}

.popcontent .litmenu {
  text-align: center;
  cursor: pointer;
  line-height: 20px;
  height: 20px;
  padding: 10px;
  color: #212121;
}

.popcontent .litmenu:hover {
  background-color: #e5e5e5;
}

.popcontent .litmenu img {
  margin-right: 5px;
}

.popcontent .litmenu span {
  position: relative;
  top: -5px;
}

.tag {
  padding: 0 7px;
  border-radius: 2px;
}

.sbtn {
  padding: 7px 31px;
}

.dialogcontent {
  margin-top: 5px;
}

.dialogcontent .left {
  width: calc(100% - 40px);
  padding: 20px;
  display: block;
}

.dialogcontent .left > div + .title2 {
  margin-top: 10px;
}

.dialogcontent .left .title2 {
  margin-bottom: 5px;
}

.dialogcontent .left .err {
  color: #f56c6c;
}

.dialogcontent .left .bottom {
  text-align: right;
  margin-top: 20px;
}

.cp {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/header2.vue